export const ERP_DEPARTMENTS = [
  { label: "Amazonas", value: "Amazonas", country: "Colombia" },
  { label: "Antioquia", value: "Antioquia", country: "Colombia" },
  { label: "Arauca", value: "Arauca", country: "Colombia" },
  { label: "Atlantico", value: "Atlantico", country: "Colombia" },
  { label: "BOGOTA DC", value: "BOGOTA DC", country: "Colombia" },
  { label: "Bogota", value: "Bogota", country: "Colombia" },
  { label: "Bolivar", value: "Bolivar", country: "Colombia" },
  { label: "Boyaca", value: "Boyaca", country: "Colombia" },
  { label: "Caldas", value: "Caldas", country: "Colombia" },
  { label: "Caqueta", value: "Caqueta", country: "Colombia" },
  { label: "Casanare", value: "Casanare", country: "Colombia" },
  { label: "Cauca", value: "Cauca", country: "Colombia" },
  { label: "Cesar", value: "Cesar", country: "Colombia" },
  { label: "Choco", value: "Choco", country: "Colombia" },
  { label: "Cordoba", value: "Cordoba", country: "Colombia" },
  { label: "Cundinamarca", value: "Cundinamarca", country: "Colombia" },
  { label: "Exterior", value: "Exterior", country: "Colombia" },
  { label: "Guainia", value: "Guainia", country: "Colombia" },
  { label: "Guaviare", value: "Guaviare", country: "Colombia" },
  { label: "Huila", value: "Huila", country: "Colombia" },
  { label: "La guajira", value: "La guajira", country: "Colombia" },
  { label: "Magdalena", value: "Magdalena", country: "Colombia" },
  { label: "Meta", value: "Meta", country: "Colombia" },
  { label: "NORTE DE SANTANDER", value: "NORTE DE SANTANDER", country: "Colombia" },
  { label: "Narino", value: "Narino", country: "Colombia" },
  { label: "Norte de santander", value: "Norte de santander", country: "Colombia" },
  { label: "Putumayo", value: "Putumayo", country: "Colombia" },
  { label: "Quindio", value: "Quindio", country: "Colombia" },
  { label: "Risaralda", value: "Risaralda", country: "Colombia" },
  { label: "San andres", value: "San andres", country: "Colombia" },
  { label: "Santander", value: "Santander", country: "Colombia" },
  { label: "Sucre", value: "Sucre", country: "Colombia" },
  { label: "Tolima", value: "Tolima", country: "Colombia" },
  { label: "Valle del cauca", value: "Valle del cauca", country: "Colombia" },
  { label: "Vaupes", value: "Vaupes", country: "Colombia" },
  { label: "Vichada", value: "Vichada", country: "Colombia" }
]
